import { Error } from "@mui/icons-material";
import {
  Chip,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import useCustomSearchParam from "../../hooks/useCustomSearchParam";
import useGetDropdownPets from "../../hooks/useGetDropdownPets";
import useUser from "../../hooks/useUser";

export default function PetFilter({ param = "pet", testId }) {
  const { t } = useTranslation();
  const { data: allPets = [], isLoading, error } = useGetDropdownPets();
  const { searchFn, searchParams } = useCustomSearchParam(param);
  const [selectedPet, setSelectedPet] = useState("");
  const userParam = searchParams.get("user");
  const { roles } = useUser();

  useEffect(() => {
    const petId = searchParams.get(param);
    if (petId) setSelectedPet(petId);
    else {
      setSelectedPet(""); 
    }
  }, [searchParams, param]);

  const pets = useMemo(() => {
    if (!allPets.length) return [];
    if (!userParam) return allPets;
    return allPets.filter(
      (pet) => Number(pet.user?.id) === Number(userParam)
    );
  }, [allPets, userParam]);

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedPet(value);
    searchFn(value);
  };

  if (isLoading) return <LinearProgress sx={{ width: "100%" }} />;
  if (error && !isLoading) return <Error color="error" />;

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{t("Pet")}</InputLabel>
      <Select
        value={selectedPet}
        label={t("Pet")}
        onChange={handleChange}
        SelectDisplayProps={{ ...(testId && { "data-testid": testId }) }}
      >
        <MenuItem value="">{t("Reset")}</MenuItem>
        {pets.map(({ id, name, user }) => (
          <MenuItem key={id} value={id}>
            {name}
            {!roles.user && user?.userDetails?.email && (
              <Chip sx={{ ml: 2 }} label={user.userDetails.email} />
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
